import ifvisible from 'ifvisible';

import constants from '@/utils/constants.js';

ifvisible.setIdleDuration(constants.IDLE_DURATION);

export function isSessionActive() {
  return ifvisible.now();
}

export function registerWakeupHandler(handler) {
  ifvisible.on('wakeup', handler);
}

export function unregisterWakeupHandler(handler) {
  ifvisible.off('wakeup', handler);
}

export function createTemporaryAccount() {
  return {
    id: 0,
    user: 0,
    firstname: 'Temporary',
    lastname: 'User',
    email: 'temporary@example.com',
    locale: 'en',
    clone: function () {
      return Object.assign({}, this);
    }
  };
}

export function isCommunicationError(error) {
  return error.toString().indexOf('401') === -1;
}

export async function fetchCurrentUser(store) {
  await store.dispatch('currentUser/fetchUser');
}

function getCurrentLanguage(store) {
  let currentUserState = store.state.currentUser;
  let account = currentUserState.account;
  let user = currentUserState.user;

  return (account && (account.locale || account.language))
    || (user && (user.language || user.locale));
}

export async function fetchCurrentAccount(store, changeLanguage, currentAccount) {
  await store.dispatch('currentUser/fetchAccount');
  changeLanguage(getCurrentLanguage(store));
}

export async function refreshSessionState({
  store,
  keycloak,
  currentUser,
  currentAccount,
  changeLanguage,
}) {
  if (keycloak.hasTemporaryToken) {
    if (!currentUser) {
      await fetchCurrentUser(store);
    }
    store.commit('currentUser/setAccount', createTemporaryAccount());
  }

  if (!currentUser) {
    await fetchCurrentUser(store);
  }

  if (!currentAccount) {
    await fetchCurrentAccount(store, changeLanguage, store.state.currentUser.account);
  }
}
